module.exports = __webpack_public_path__ + "static/media/main-image.mobile.368a006d.jpeg";